import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=1afd8858&scoped=true"
import script from "./Testimonial.vue?vue&type=script&lang=js"
export * from "./Testimonial.vue?vue&type=script&lang=js"
import style0 from "./Testimonial.vue?vue&type=style&index=0&id=1afd8858&prod&lang=css"
import style1 from "./Testimonial.vue?vue&type=style&index=1&id=1afd8858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afd8858",
  null
  
)

export default component.exports